export default {
    data () {
        return {
            categoriesToInclude: [
                "I-Codes", "Standards", "Locations", "Commentaries",
                "Resources", "Topics", "Publisher", "Collections"
            ]
        }
    },
    methods: {
        sortedCategories(categories, key = 'name') {
            const categorySortOrder = _.invert(this.categoriesToInclude);
            return categories.sort((a, b) => {
                let ai = categorySortOrder[a[key]];
                let bi = categorySortOrder[b[key]];
                return ai - bi;
            });
        },
        getFlatCategories() {
            const temp = this.$store.getters.getSearchNavigationCategories;
            const storeCategories = JSON.parse(JSON.stringify(temp));
            const categories = [];

            function flatten(nodes) {
                nodes.forEach(node => {
                    categories.push(node);
                    if (node.children && node.children.length) {
                        flatten(node.children);
                    }
                });
            }

            if (storeCategories.Category) flatten(storeCategories.Category);
            if (storeCategories.Location) flatten(storeCategories.Location);

            return categories;
        },

        getCategoryInfoByCategoryName(categoryName) {
            const categories = this.getFlatCategories();
            return categories.find(item => item.name === categoryName);
        },
    }
}
